export default __webpack_public_path__ + "static/logo-7e9f0a7ecbe998ea034f3a2a95c95da9.svg";